// extracted by mini-css-extract-plugin
export default {"agentsBox":"AgentsBox-module__agentsBox-QG2D","avatar":"AgentsBox-module__avatar-V5v0"};